import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50aea24e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"flex justify-between\" data-v-50aea24e><div class=\"P13\" data-v-50aea24e>P13</div><div class=\"F13\" data-v-50aea24e>F13</div><div class=\"P15\" data-v-50aea24e>P15</div><div class=\"F15\" data-v-50aea24e>F15</div><div class=\"P17\" data-v-50aea24e>P17/20</div><div class=\"F17\" data-v-50aea24e>F17/20</div></div>", 1)
const _hoisted_2 = { class: "md:container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ])
  ], 64))
}